export const USER_INFO = [
	"sex",
	"username",
	"age",
	"height",
	"weight",
	"hypertension",
	"diabetes"
];